export const modules = state => state.inventory.modules.list;
